<template>
  <div class="content container-fluid">
    <br />
    <el-tabs v-model="activeName" type="border-card" @tab-click="handleClick">
      <el-tab-pane label="在线签名订单" name="autoSignOrder">
        <el-table :data="autoSignOrderList">
          <el-table-column prop="orderNum" label="订单号"></el-table-column>
          <el-table-column prop="orderDesc" label="订单描述"></el-table-column>
          <el-table-column prop="price" label="订单价格"></el-table-column>
          <el-table-column prop="payWay" :formatter="payWayFormat" label="支付方式"></el-table-column>
          <el-table-column prop="orderStatus" :formatter="superSignOrderStatusFormat" label="订单状态"></el-table-column>
          <el-table-column prop="createTime" sortable :formatter="vueFormatDateTime" label="创建时间"></el-table-column>
        </el-table>
      </el-tab-pane>
      <el-tab-pane label="超级签名订单" name="superSignOrder">
        <el-table :data="superSignOrderList">
          <el-table-column prop="orderNum" label="订单号"></el-table-column>
          <el-table-column prop="payNum" label="购买超级签名次数"></el-table-column>
          <el-table-column prop="price" label="价格"></el-table-column>
          <el-table-column prop="payWay" label="支付方式" :formatter="payWayFormat"></el-table-column>
          <el-table-column prop="orderStatus" :formatter="fenfaOrderStatusFormat" label="订单状态"></el-table-column>
          <el-table-column prop="createTime" sortable :formatter="vueFormatDateTime" label="创建时间"></el-table-column>
        </el-table>
      </el-tab-pane>
      <el-tab-pane label="分发订单" name="fenfaOrder">
        <el-table :data="orderList">
          <el-table-column prop="orderId" label="订单号"></el-table-column>
          <el-table-column prop="goodsName" label="商品名称" width="250"></el-table-column>
          <el-table-column prop="goodsPrice" :formatter="goodsPriceFormat" label="商品价格"></el-table-column>
          <el-table-column prop="payDownNum" label="购买下载次数"></el-table-column>
          <el-table-column prop="payWay" label="支付方式" :formatter="payWayFormat"></el-table-column>
          <el-table-column prop="orderStatus" :formatter="fenfaOrderStatusFormat" label="订单状态"></el-table-column>
          <el-table-column prop="createTime" sortable :formatter="vueFormatDateTime" label="创建时间"></el-table-column>
        </el-table>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
var self;
export default {
  mounted() {
    self = this;
    this.get_auto_sign_order_list();
  },
  data() {
    return {
      page: 1,
      pageSize: 20,
      orderList: [],
      autoSignOrderList: [],
      activeName: "autoSignOrder",
      superSignOrderList: []
    };
  },
  methods: {
    payWayFormat(row, column, value) {
      var paWay = "";
      switch (value) {
        case 1:
          paWay = "微信";
          break;
        case 2:
          paWay = "支付宝";
          break;
      }
      return paWay;
    },
    superSignOrderStatusFormat(row, column, value) {
      return value == 1 ? "已支付" : "待支付";
    },
    fenfaOrderStatusFormat(row, column, value) {
      var status = "待支付";
      switch (value) {
        case 2:
          status = "已支付";
          break;
      }
      return status;
    },
    goodsPriceFormat(row, column, value) {
      return value / 100;
    },
    get_auto_sign_order_list: function() {
      this.$http
        .post(this._Global.HTTP_SERVER + "/auth/autoSignOrder/list", {
          authToken: this.getToken()
        })
        .then(response => {
          self.respDataHandle(response.body, data => {
            self.autoSignOrderList = data;
          });
        });
    },
    handleClick(tab, event) {
      var paneName = tab.paneName;
      switch (paneName) {
        case "autoSignOrder":
          this.get_auto_sign_order_list();
          break;
        case "superSignOrder":
          this.$http
            .post(this._Global.HTTP_SERVER + "/auth/superSign/order/list", {
              authToken: this.getToken
            })
            .then(response => {
              this.respDataHandle(response.body, data => {
                this.superSignOrderList = data;
              });
            });
          break;
        case "fenfaOrder":
          var url = this._Global.HTTP_SERVER + "/auth/order/list";
          this.$http
            .post(url, {
              authToken: this.getToken()
            })
            .then(response => {
              this.respDataHandle(response.body, function(data) {
                self.orderList = data;
              });
            });
          break;
      }
    }
  }
};
</script>

<style scoped>
table {
  margin-bottom: 0;
  margin-top: 0;
}
.orders-content {
  width: 100%;
}
</style>


// WEBPACK FOOTER //
// src/components/Order.vue